// Module
var code = `{{#if .messageInfo.Text}}
    <div class="js-broker-message-content  bmcontent-{{.messageInfo.DisplayMethod}}" id={{brokerMsgScreenID}}>
        <iframe srcdoc="{{.messageInfo.Text}}" id="iframe_{{brokerMsgScreenID}}" on-load="onIframeLoad" class="broker-message-content-iframe"></iframe>
    </div>
{{else}}
    <div class="js-tercera-label" style="position:absolute;left:0;right:0;top:0;bottom:0;text-align:center;line-height:213px;">
        {{.noHtmlMessage}}
    </div>
{{/if}}`;
// Exports
export default code;